import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_application_lender_tier_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import {
  applicationKeys,
  parseApplicationKey,
} from '../../cache-keys/applicationKeys';

export function useLenderTier(applicationID: string) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationKeys.lenderTier({
    applicationID,
  });
  return useQuery(
    cacheKey,
    queryFunction(
      loan_application_lender_tier_api.getLenderTier(api),
      ({ queryKey }) => parseApplicationKey(queryKey).applicationID ?? ''
    ),
    {
      enabled: state.user.token.length > 0 && !!applicationID,
    }
  );
}
